/* CNOIR Our Story chapters: pillar switch, sticky chapter bar under the header, active chapter. */
(function () {
  var root = document.querySelector('[data-cnab]');
  if (!root) return;

  // Culture / Couture switch (ARIA tabs with arrow keys)
  var tabs = [].slice.call(root.querySelectorAll('.cnab__tabs [role=tab]'));
  function select(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      panel.hidden = !on;
      var pics = root.querySelector('[data-pics-for="' + panel.dataset.pics + '"]');
      if (pics) pics.hidden = !on;
    });
    if (focus) tab.focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t); });
    t.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (n) { e.preventDefault(); select(n, true); }
    });
  });

  // Keep the chapter bar just under the sticky store header
  var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
  var ticking = false;
  function place() {
    ticking = false;
    var top = 0;
    if (header) {
      var b = header.getBoundingClientRect().bottom;
      if (b > 0) top = Math.round(b);
    }
    root.style.setProperty('--cnab-top', top + 'px');
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
  window.addEventListener('resize', place);
  place();

  // Underline the chapter being read
  var links = [].slice.call(root.querySelectorAll('.cnab__toc a'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (l) { var t = document.querySelector(l.getAttribute('href')); if (t) io.observe(t); });
  }
})();
